import { put, takeLatest, all } from 'redux-saga/effects';
import { notification } from 'antd';
import TrackerActions from '@Actions/trackerActions';
import ResourceActions, { resourceActionTypes } from '@Actions/production/resourceActions';
import ResourceServices from '../../services/production/resourceServices';

/**
 * @param action
 */
function* _createResource(action) {
  try {
    yield put(ResourceActions.createResourceLoading(true));
    const resource = yield ResourceServices.createResource(action.payload);
    if (resource.success) {
      yield put(TrackerActions.trackAction(resourceActionTypes.CREATE_RESOURCE.SUCCESS, resource.data));
      notification.open({
        type: 'success',
        message: ' Resource successfully created',
        duration: 4,
        placement: 'top',
      });
      action.callback(resource?.data?.[0]);
    } else {
      notification.open({
        type: 'error',
        message: resource?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(ResourceActions.createResourceLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
    });
    yield put(ResourceActions.createResourceLoading(false));
    yield put(TrackerActions.trackAction(resourceActionTypes.CREATE_RESOURCE.ERROR, error));
  }
}

/**
 *
 */
function* createResource() {
  yield takeLatest(resourceActionTypes.CREATE_RESOURCE.REQUEST, _createResource);
}

/**
 * @param action
 */
function* _updateResource(action) {
  try {
    yield put(ResourceActions.updateResourceLoading(true));
    const resource = yield ResourceServices.updateResource(action.payload);
    if (resource.success) {
      yield put(TrackerActions.trackAction(resourceActionTypes.UPDATE_RESOURCE.SUCCESS, resource.data));
      notification.open({
        type: 'success',
        message: 'Resource successfully updated',
        duration: 4,
        placement: 'top',
      });
      action.callback();
      yield put(ResourceActions.updateResourceLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: resource?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(ResourceActions.updateResourceLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(ResourceActions.updateResourceLoading(false));
    yield put(TrackerActions.trackAction(resourceActionTypes.UPDATE_RESOURCE.ERROR, error));
  }
}

/**
 *
 */
function* updateResource() {
  yield takeLatest(resourceActionTypes.UPDATE_RESOURCE.REQUEST, _updateResource);
}

/**
 * @param action
 */
function* _getResource(action) {
  try {
    yield put(ResourceActions.getResourceLoading(true));
    const {
      orgId, page, limit, searchKeyword, tenantIds, resourceType, resourceStatus, isDropdown,
    } = action;
    const resources = yield ResourceServices.getResource(orgId, page, limit, searchKeyword, tenantIds, resourceType, resourceStatus);
    yield put(ResourceActions.getResourceSuccess(resources?.data, isDropdown));
    yield put(ResourceActions.getResourceLoading(false));
  } catch (error) {
    yield put(ResourceActions.getResourceLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(resourceActionTypes.GET_RESOURCE.ERROR, error));
  }
}

/**
 *
 */
function* getResource() {
  yield takeLatest(resourceActionTypes.GET_RESOURCE.REQUEST, _getResource);
}

/**
 * @param action
 */
function* _getResourceById(action) {
  try {
    yield put(ResourceActions.getResourceByIdLoading(true));
    const {
      tenantId, tenantSellerId, resourceId, searchKeyword,
    } = action;
    const selectedResource = yield ResourceServices.getResource(tenantId, tenantSellerId, resourceId, searchKeyword);
    yield put(ResourceActions.getResourceByIdSuccess(selectedResource?.date));
    yield put(ResourceActions.getResourceByIdLoading(false));
  } catch (error) {
    yield put(ResourceActions.getResourceByIdLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(resourceActionTypes.GET_RESOURCE_BY_ID.ERROR, error));
  }
}

/**
 *
 */
function* getResourceById() {
  yield takeLatest(resourceActionTypes.GET_RESOURCE_BY_ID.REQUEST, _getResourceById);
}

/**
 * @param action
 */
function* _updateResourceStatus(action) {
  try {
    yield put(ResourceActions.updateResourceStatusLoading(true));
    const {
      payload, callback,
    } = action;
    const resource = yield ResourceServices.updateResourceStatus(payload);

    if (resource.success) {
      notification.open({
        type: 'success',
        message: ' Resource successfully deleted',
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: resource?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(ResourceActions.updateResourceStatusLoading(false));
  } catch (error) {
    yield put(ResourceActions.updateResourceStatusLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(resourceActionTypes.UPDATE_STATUS_RESOURCE.ERROR, error));
  }
}

/**
 *
 */
function* updateResourceStatus() {
  yield takeLatest(resourceActionTypes.UPDATE_STATUS_RESOURCE.REQUEST, _updateResourceStatus);
}

/**
 * @param action
 */
function* _deleteResource(action) {
  try {
    yield put(ResourceActions.deleteResourceLoading(true));
    const resource = yield ResourceServices.deleteResource(action.payload);

    if (resource.success) {
      notification.open({
        type: 'success',
        message: ' Resource successfully deleted',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: resource?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(ResourceActions.deleteResourceLoading(false));
  } catch (error) {
    yield put(ResourceActions.deleteResourceLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(resourceActionTypes.DELETE_RESOURCE.ERROR, error));
  }
}

/**
 *
 */
function* deleteResource() {
  yield takeLatest(resourceActionTypes.DELETE_RESOURCE.REQUEST, _deleteResource);
}

/**
 * @param action
 */
function* _createResourceGroup(action) {
  try {
    yield put(ResourceActions.createResourceGroupLoading(true));
    const resource = yield ResourceServices.createResourceGroup(action.payload);
    if (resource.success) {
      yield put(TrackerActions.trackAction(resourceActionTypes.CREATE_RESOURCE_GROUP.SUCCESS, resource.data));
      notification.open({
        type: 'success',
        message: ' Resource Group successfully created',
        duration: 4,
        placement: 'top',
      });
      action.callback(resource?.data);
    } else {
      notification.open({
        type: 'error',
        message: resource?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(ResourceActions.createResourceGroupLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
    });
    yield put(ResourceActions.createResourceGroupLoading(false));
    yield put(TrackerActions.trackAction(resourceActionTypes.CREATE_RESOURCE_GROUP.ERROR, error));
  }
}

/**
 *
 */
function* createResourceGroup() {
  yield takeLatest(resourceActionTypes.CREATE_RESOURCE_GROUP.REQUEST, _createResourceGroup);
}

/**
 * @param action
 */
function* _updateResourceGroup(action) {
  try {
    yield put(ResourceActions.updateResourceGroupLoading(true));
    const resource = yield ResourceServices.updateResourceGroup(action.payload);
    if (resource.success) {
      yield put(TrackerActions.trackAction(resourceActionTypes.UPDATE_RESOURCE.SUCCESS, resource.data));
      notification.open({
        type: 'success',
        message: 'Resource Group successfully updated',
        duration: 4,
        placement: 'top',
      });
      action.callback();
      yield put(ResourceActions.updateResourceGroupLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: resource?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(ResourceActions.updateResourceGroupLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(ResourceActions.updateResourceGroupLoading(false));
    yield put(TrackerActions.trackAction(resourceActionTypes.UPDATE_RESOURCE.ERROR, error));
  }
}

/**
 *
 */
function* updateResourceGroup() {
  yield takeLatest(resourceActionTypes.UPDATE_RESOURCE_GROUP.REQUEST, _updateResourceGroup);
}

/**
 * @param action
 */
function* _getResourceGroup(action) {
  try {
    yield put(ResourceActions.getResourceGroupLoading(true));
    const {
      orgId, searchKeyword, callback,
    } = action;
    const resourcesGroup = yield ResourceServices.getResourceGroup(orgId);
    yield put(ResourceActions.getResourceGroupSuccess(resourcesGroup?.data));
    yield put(ResourceActions.getResourceGroupLoading(false));
    if (callback) {
      callback(resourcesGroup?.data);
    }
  } catch (error) {
    yield put(ResourceActions.getResourceGroupLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(resourceActionTypes.GET_RESOURCE_GROUP.ERROR, error));
  }
}

/**
 *
 */
function* getResourceGroup() {
  yield takeLatest(resourceActionTypes.GET_RESOURCE_GROUP.REQUEST, _getResourceGroup);
}

/**
 * @param action
 */
function* _deleteResourceGroup(action) {
  try {
    yield put(ResourceActions.deleteResourceGroupLoading(true));
    const resource = yield ResourceServices.deleteResourceGroup(action.payload);

    if (resource.success) {
      notification.open({
        type: 'success',
        message: 'Resource Group successfully deleted',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: resource?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(ResourceActions.deleteResourceGroupLoading(false));
  } catch (error) {
    yield put(ResourceActions.deleteResourceGroupLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(resourceActionTypes.DELETE_RESOURCE_GROUP.ERROR, error));
  }
}

/**
 *
 */
function* deleteResourceGroup() {
  yield takeLatest(resourceActionTypes.DELETE_RESOURCE_GROUP.REQUEST, _deleteResourceGroup);
}

/**
 *
 */
export default function* resourceSaga() {
  yield all([
    createResource(), getResource(), updateResource(), getResourceById(), updateResourceStatus(), deleteResource(), createResourceGroup(),
    updateResourceGroup(), deleteResourceGroup(), getResourceGroup(),
  ]);
}
